module.exports = __webpack_public_path__ + "static/media/Abigail Remy Headshot_1592393687159.1f12437a.png";